import {performHttpRequest} from "../http";

export async function getWeatherData(lng, lat) {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/rest/weatherapi/weather/lng/' + lng + '/lat/' + lat,
        'GET',
    )
}
